import { z } from "zod";
import { emailSchema } from "../common/email.js";

export const verifyOtpSchema = z.object({
	email: emailSchema,
	code: z.string().length(6, { message: "Code must be 6 digits" }),
});

export type VerifyOtpPayload = z.infer<typeof verifyOtpSchema>;
